import React from 'react';
import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';

// Shared shell for Privacy / Terms / Cookie pages: navy hero band + prose body.
export default function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <div className="bg-white">
      <section className="bg-[#0f2b4a] text-white">
        <div className="max-w-4xl mx-auto px-4 py-14">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
            <Scale size={14} className="text-blue-300" />
            <span className="text-blue-200 text-xs font-medium uppercase tracking-wide">Legal</span>
          </div>
          <h1 className="text-3xl lg:text-4xl font-extrabold mb-2">{title}</h1>
          <p className="text-blue-200/80 text-sm">Last updated: {lastUpdated}</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8 text-gray-700 text-sm leading-relaxed [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-[#0f2b4a] [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_a]:text-blue-700 [&_a]:underline">
          {children}
        </div>
        <div className="mt-12 pt-8 border-t border-gray-100 flex flex-wrap gap-4 text-sm">
          <Link to="/privacy-policy" className="text-blue-700 hover:underline">Privacy Policy</Link>
          <Link to="/terms" className="text-blue-700 hover:underline">Terms &amp; Conditions</Link>
          <Link to="/cookie-policy" className="text-blue-700 hover:underline">Cookie Policy</Link>
          <Link to="/contact" className="text-blue-700 hover:underline">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}
